<template>
  <div>
    <a v-if="Liste" class="el-button YeniBtn el-button--success el-button--small" @click="EmanetKontrol">Manuel Emanet
      Kontrol</a>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Emanet Kaydı Yok"
      type="success"
      :closable="false"
      v-if="!Liste && !lo">
    </el-alert>
    <el-table
      class="table-xs"
      :data="Liste"
      v-if="Liste && !lo"
      row-key="id"
      :height="Height"
      show-summary
      :summary-method="TableFooter">
      <el-table-column
        label="Tarih"
        prop="Tarih"
        width="100"
      >
      </el-table-column>
      <el-table-column
        label="Makbuz No"
        prop="mNo"
        width="150">
      </el-table-column>
      <el-table-column
        label="Kategori"
        prop="Kategori">
      </el-table-column>
      <el-table-column
        label="Ödeme"
        prop="Odeme"
        align="right"
        width="90">
      </el-table-column>
      <el-table-column
        label="Tahakkuk"
        prop="Tahakkuk"
        align="right"
        width="90">
      </el-table-column>
      <el-table-column
        label="Kalan"
        prop="Kalan"
        align="right"
        width="90">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import Yukleniyor from "../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Kisi_id"],
  data() {
    return {
      lo: true,
      Liste: null,
      AltToplam: 0,
      Height: window.innerHeight - 215
    }
  },
  methods: {
    EmanetKontrol() {
      if (this.Kisi_id) {
        this.$store.dispatch("Get", {path: 'yonetim/kisi/ekran/' + this.Kisi_id + '/emanetkontrol'})
          .then(response => {
            this.SayfaYukle();
          })

      }
    },
    TableFooter() {
      const sums = [];
      sums[5] = this.AltToplam;

      return sums;
    },
    SayfaYukle() {
      if (this.Kisi_id) {
        this.$store.dispatch("Get", {path: 'yonetim/kisi/ekran/' + this.Kisi_id + '/emanet'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.AltToplam = response.AltToplam;
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      }


    },

  },
  created() {
    this.SayfaYukle()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/kisi/Ekran/KisiEmanet.vue